import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Contact API
export const submitContact = async (contactData) => {
  const response = await axios.post(`${API}/contact`, contactData);
  return response.data;
};

export const getContacts = async () => {
  const response = await axios.get(`${API}/contact`);
  return response.data;
};

// Blog API
export const getBlogPosts = async (category = null, limit = null) => {
  const params = new URLSearchParams();
  if (category) params.append('category', category);
  if (limit) params.append('limit', limit);
  
  const url = params.toString() ? `${API}/blog?${params}` : `${API}/blog`;
  const response = await axios.get(url);
  return response.data;
};

export const getBlogPost = async (id) => {
  const response = await axios.get(`${API}/blog/${id}`);
  return response.data;
};

export const createBlogPost = async (postData) => {
  const response = await axios.post(`${API}/blog`, postData);
  return response.data;
};

export const updateBlogPost = async (id, postData) => {
  const response = await axios.put(`${API}/blog/${id}`, postData);
  return response.data;
};

export const deleteBlogPost = async (id) => {
  const response = await axios.delete(`${API}/blog/${id}`);
  return response.data;
};

// Slang API
export const getSlangWords = async () => {
  const response = await axios.get(`${API}/slang`);
  return response.data;
};

export const getSlangOfTheDay = async () => {
  const response = await axios.get(`${API}/slang/today`);
  return response.data;
};

export const getRandomSlang = async () => {
  const response = await axios.get(`${API}/slang/random`);
  return response.data;
};

// Dashboard Stats
export const getDashboardStats = async () => {
  const response = await axios.get(`${API}/stats`);
  return response.data;
};

// Image Upload
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

// Seed database (for initial setup)
export const seedDatabase = async () => {
  const response = await axios.post(`${API}/seed`);
  return response.data;
};

export default {
  submitContact,
  getContacts,
  getBlogPosts,
  getBlogPost,
  createBlogPost,
  updateBlogPost,
  deleteBlogPost,
  getSlangWords,
  getSlangOfTheDay,
  getRandomSlang,
  getDashboardStats,
  uploadImage,
  seedDatabase
};
